import { action, computed, observable } from "mobx";
import { ViewModelBase } from "Core/ViewModels/ViewModelBase";
import { UserAccessModel } from "Custom/Models/Domain/UserAccess/UserAccessModel";
import { validate, ValidationError } from "class-validator";
import { FieldType } from "Core/Utils/Utils";
import { StoresInstance } from "Custom/Stores/Stores";
import { AccountStore } from "Custom/Stores/Domain";

export default class UserAccessViewModel extends ViewModelBase<UserAccessModel> {
    public afterUpdate: undefined;
    public beforeUpdate: undefined;

    private accountStore: AccountStore = StoresInstance.domain.AccountStore;

    constructor() {
        super(new UserAccessModel());
        this.setDecorators(UserAccessModel);
    }

    @observable
    public haveSubmitted = false;

    @action
    setallowMarketing = (value: boolean) => {
        this.model.allowMarketing = value;
    };

    @computed get telephone(): string {
        return this.model.telephone;
    }

    @action setTelephone = (value: string): void => {
        this.model.telephone = value;
    };

    @computed
    public get telephoneError(): string {
        const result = this.validateDecorators("telephone");
        return !this.haveSubmitted ? "" : result.isValid ? "" : result.errorMessage;
    }

    @computed
    public get displayNameError(): string {
        const result = this.validateDecorators("displayName");
        return !this.haveSubmitted ? "" : result.isValid ? "" : result.errorMessage;
    }

    @computed
    public get emailError(): string {
        const result = this.validateDecorators("email");
        return !this.haveSubmitted ? "" : result.isValid ? "" : result.errorMessage;
    }

    @computed
    public get companyError(): string {
        const result = this.validateDecorators("company");
        return !this.haveSubmitted ? "" : result.isValid ? "" : result.errorMessage;
    }

    @computed get displayName(): string {
        return this.model.displayName;
    }

    @action setDisplayName = (value: string): void => {
        this.model.displayName = value;
    };

    @computed get allowMarketing(): boolean {
        return this.model.allowMarketing;
    }

    @action setAllowMarketing = (value: boolean): void => {
        this.model.allowMarketing = value;
    };

    @computed get company(): string {
        return this.model.company;
    }

    @action setCompany = (value: string): void => {
        this.model.company = value;
    };

    @computed get email(): string {
        return this.model.email;
    }

    @action setEmail = (value: string): void => {
        this.model.email = value;
    };

    @computed get GetUseAdminGrids(): boolean {
        return this.accountStore.GetUseAdminGrids;
    }

    @computed get GetUseAdminControlsLight(): boolean {
        return this.accountStore.GetUseAdminControlsLight;
    }

    @computed get isInerror(): boolean {
        let retVal: boolean = false;
        for (let key in this.model) {
            if (this.isFieldValid(key as any) === false) {
                retVal = true;
                break;
            }
        }
        return !this.haveSubmitted ? false : retVal;
    }

    //This must be present in your viewmodel. Just return true if you dont need to validate anything.
    //keyof BlankModel & string lets you add type checking to the fieldName
    //I am using the validator package to make checking easier https://www.npmjs.com/package/validator
    public isFieldValid(fieldName: keyof FieldType<UserAccessModel>): boolean {
        const { isValid, errorMessage } = this.validateDecorators(fieldName);

        //You need to this two properties after validation
        this.setError(fieldName, errorMessage);
        this.setValid(fieldName, isValid);

        return isValid;
    }

    @action
    Validate = (): Promise<ValidationError[]> => {
        this.haveSubmitted = true;
        let promise = validate(this.model).then((errors) => {
            // errors is an array of validation errors
            let retVal: ValidationError[] = [];
            if (errors.length > 0) {
                retVal = errors;
                console.log("validation failed");
            } else {
                console.log("validation succeed");
            }

            return retVal;
        });

        return promise;
    };

    isInError = (fieldName: string): boolean => {
        let isValid = this.getValid(fieldName);
        return !isValid;
    };

    @action
    isInErrorClass = (fieldName: "email" | "telephone" | "displayName" | "company"): string => {
        const { isValid, errorMessage } = this.validateDecorators(fieldName);
        return !this.haveSubmitted ? "" : isValid ? "" : "inerror";
    };

    //@action
    Store = () => {
        this.Validate().then((errors) => {
            if (errors.length === 0) {
                this.accountStore.setUserState(this.model.convertToDto());
            }
        });
    };
}
